import { useApp } from 'context/AppContext';
import { Container, Box, Title } from './Styles';
import { Offer, DailyBonus, VipBonus } from 'components';
import { Fragment, useEffect, useState } from 'react';
import storeService from 'services/store.service';
import { currentContentConfig } from 'utils/handleCurrentContentConfig';

const Offers = ({ store }) => {
  const { state } = useApp();
  const { storeType, storeEvent, dailyBonusTime } = state;
  const isBuyPage = storeType === 'BP';

  const { evs, bPe } = store || {};
  const { pks } = bPe || {};

  const [offers, setOffers] = useState([]);
  const [dailyBonus, setDailyBonus] = useState();
  const [vipBonus, setVipBonus] = useState();
  const isAscending = pks.at(0)?.cot < pks.at(-1)?.cot;

  useEffect(() => {
    const { offers, dailyBonus, vipGift } = storeService.getOffers({ event: storeEvent, data: evs });
    setOffers(offers);
    setDailyBonus(dailyBonus);
    setVipBonus(vipGift);
  }, [store]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [storeType]);

  const renderDailyBonus = () =>
    (dailyBonus || dailyBonusTime) && (
      <Container>
        <Title>Free Daily bonus</Title>
        <Box>
          <DailyBonus background={currentContentConfig.offerBackground.bgRed} dailyBonus={dailyBonus} />
        </Box>
      </Container>
    );

  const handleVipExpire = () => {
    setVipBonus(null);
  };

  const renderVIPBonus = () => {
    if (!vipBonus) return null;
    return (
      <Container>
        <Title>VIP holiday gift</Title>
        <Box>
          <VipBonus vipBonus={vipBonus} onExpire={handleVipExpire} />
        </Box>
      </Container>
    );
  };

  return isBuyPage ? (
    <Fragment>
      {renderVIPBonus()}
      <Container $offersLength={pks.length}>
        <Title>Daily offers</Title>
        <Box>
          {pks.map((offer, index, { length }) => (
            <Offer
              key={index}
              offer={{ ...offer, assetKey: `regular${isAscending ? index + 1 : length - index}` }}
              background={currentContentConfig.offerBackground.bgPurple}
              offersLength={length}
            />
          ))}
        </Box>
      </Container>
      {renderDailyBonus()}
    </Fragment>
  ) : (
    <Fragment>
      {renderVIPBonus()}
      {Object.values(offers).map(({ data, title }, index) => (
        <Fragment key={index}>
          <Container $offersLength={data.length}>
            <Title>{title}</Title>
            <Box>
              {data.map((offer, i) => (
                <Offer
                  key={`${offer.izid}-${i}`}
                  offer={offer}
                  background={currentContentConfig.offerBackground.bgBlue}
                  offersLength={data.length}
                />
              ))}
            </Box>
          </Container>
          {index === 0 && renderDailyBonus()}
        </Fragment>
      ))}
    </Fragment>
  );
};

export default Offers;
